import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { BrandState } from "src/types/brand.types";

const initialState: BrandState = {
  createBrand: {
    loading: false,
    data: null,
    error: null,
  },
  editBrand: {
    loading: false,
    data: null,
    error: null,
  },
  brandList: {
    loading: false,
    data: null,
    error: null,
  },
  deleteBrand: {
    loading: false,
    data: null,
    error: null,
  },
};

const brandSlice = createSlice({
  name: "brand",
  initialState,
  reducers: {
    // create brand actions
    createBrandRequest: (state, action: PayloadAction<any>) => {
      state.createBrand.loading = true;
      state.createBrand.data = null;
      state.createBrand.error = null;
    },
    createBrandSuccess: (state, action: PayloadAction<any>) => {
      state.createBrand.loading = false;
      state.createBrand.data = action.payload;
      state.createBrand.error = null;
    },
    createBrandError: (state, action: PayloadAction<string>) => {
      state.createBrand.loading = false;
      state.createBrand.data = null;
      state.createBrand.error = action.payload;
    },
    resetCreateBrand: (state) => {
      state.createBrand = { loading: false, data: null, error: null };
    },

    // edit brand actions
    editBrandRequest: (state, action: PayloadAction<any>) => {
      state.editBrand.loading = true;
      state.editBrand.data = null;
      state.editBrand.error = null;
    },
    editBrandSuccess: (state, action: PayloadAction<any>) => {
      state.editBrand.loading = false;
      state.editBrand.data = action.payload;
      state.editBrand.error = null;
    },
    editBrandError: (state, action: PayloadAction<string>) => {
      state.editBrand.loading = false;
      state.editBrand.data = null;
      state.editBrand.error = action.payload;
    },
    resetEditBrand: (state) => {
      state.editBrand = { loading: false, data: null, error: null };
    },

    // get brand list
    getBrandListRequest: (
      state,
      action: PayloadAction<{
        page?: number;
        limit: number;
        search?: string;
        status?: "active" | "inactive";
      }>
    ) => {
      state.brandList.loading = true;
      state.brandList.data = null;
      state.brandList.error = null;
    },
    getBrandListSuccess: (state, action: PayloadAction<any>) => {
      state.brandList.loading = false;
      state.brandList.data = action.payload;
      state.brandList.error = null;
    },
    getBrandListError: (state, action: PayloadAction<string>) => {
      state.brandList.loading = false;
      state.brandList.data = null;
      state.brandList.error = action.payload;
    },
    resetBrandList: (state) => {
      state.brandList = { loading: false, data: null, error: null };
    },

    // delete brand actions
    deleteBrandRequest: (state, action: PayloadAction<string>) => {
      state.deleteBrand.loading = true;
      state.deleteBrand.data = null;
      state.deleteBrand.error = null;
    },
    deleteBrandSuccess: (state, action: PayloadAction<any>) => {
      state.deleteBrand.loading = false;
      state.deleteBrand.data = action.payload;
      state.deleteBrand.error = null;
    },
    deleteBrandError: (state, action: PayloadAction<string>) => {
      state.deleteBrand.loading = false;
      state.deleteBrand.data = null;
      state.deleteBrand.error = action.payload;
    },
    resetDeleteBrand: (state) => {
      state.deleteBrand = { loading: false, data: null, error: null };
    },
  },
});

export const {
  createBrandRequest,
  createBrandSuccess,
  createBrandError,
  resetCreateBrand,

  editBrandRequest,
  editBrandSuccess,
  editBrandError,
  resetEditBrand,

  getBrandListRequest,
  getBrandListSuccess,
  getBrandListError,
  resetBrandList,

  deleteBrandRequest,
  deleteBrandSuccess,
  deleteBrandError,
  resetDeleteBrand,
} = brandSlice.actions;

export default brandSlice.reducer;
